// ** React Imports
import { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import {
    Divider,
    IconButton,
    Tooltip,
    Fab,
} from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import { useNavigate, useParams } from "react-router-dom";
import { Controller, set, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'
import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';
import MsiDatagridAutoPlain from '../../../../components/custom/MsiDatagridAutoPlain';
import MsiDatagridCheckbox from '../../../../components/custom/MsiDatagridAutoCheckbox';
import { useToast } from '../../../../components/ToastProvider';
import AttachmentFab from '../../../../components/attachment/AttachmentFab';
export default function Detail() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { id } = useParams();
    const { showToast, hideToast } = useToast();
    // ** State
    const [listDetail, setListDetail] = useState<any[]>([])
    const [historyPembelian, setHistoryPembelian] = useState<any[]>([])
    const [openDialogHistory, setOpenDialogHistory] = useState(false)
    const [selectedList, setSelectedList] = useState<any[]>([])
    const [selectedPR, setSelectedPR] = useState<any>(null)
    const [pTgl, setPTgl] = useState<any>(null)
    const [listPrOutStanding, setListPrOutStanding] = useState<any[]>([])
    const [openDialogPrOutstanding, setOpenDialogPrOutstanding] = useState(false)
    const [isOto, setIsOto] = useState<any>(null)
    const [isAktif, setIsAktif] = useState<any>(null)
    const [otNow, setOtNow] = useState<any>(null)
    const [otMax, setOtMax] = useState<any>(null)
    const [totalAll, setTotalAll] = useState<any>({})
    const [isKirimWa, setIsKirimWa] = useState<any>(null)
    const [modeSave, setModeSave] = useState<any>(null)
    // Dokumen tanpa level otorisasi (otMax = 0) tetap boleh diedit
    // selama PO belum aktif/final.
    const canEdit = Number(isAktif) === 0 && (
        Number(otMax) === 0 || Number(otNow) < Number(otMax)
    )

    const toNumber = (value: any): number => {
        if (value === null || value === undefined || value === '') return 0
        if (typeof value === 'number') return Number.isFinite(value) ? value : 0

        const normalized = String(value)
            .replace(/\./g, '')
            .replace(',', '.')

        const parsed = Number(normalized)

        return Number.isFinite(parsed) ? parsed : 0
    }

    const hasReceived = (row: any): boolean => {
        const data = row?.data ?? row
        return toNumber(data?.qty_datang) > 0
    }
    useEffect(() => {
        getDetail()
    }, [])
    const getDetail = () => {
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })
        const url = apiUrl.apiUrl + '/purchasing/po/detail-po'
        axios
            .get(url, {
                params: { pbpo_id: id },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data[0]
                    const detail = response.data.detail.map((row: any, index: any) => ({
                        ...row,
                        id: index + 1
                    }));
                    setValue('supplier', data?.nama_vendor)
                    setValue('keterangan', data?.keterangan)
                    setValue('pbsupplier_id', data.pbsupplier_id)
                    setIsKirimWa(data.is_kirim_whatsapp)
                    setPTgl(data?.tgl)
                    setListDetail(detail)
                    const totals = detail.reduce((acc: any, row: any) => {
                        return {
                            qty_order: (acc.qty_order || 0) + toNumber(row.qty_order),
                            qty_datang: (acc.qty_datang || 0) + toNumber(row.qty_datang),
                            total: (acc.total || 0) + toNumber(row.total),
                            jumlah_barang: detail.length
                        }
                    }, {})
                    setTotalAll(totals)
                    getCheck()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }
    const getPrOutStanding = () => {
        const url = apiUrl.apiUrl + '/purchasing/po/list-po?tglAwal=2020-01-01&tglAkhir=2999-01-01&mode=0'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    setListPrOutStanding(response.data.data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }
    const getCheck = () => {
        const url = apiUrl.apiUrl + '/purchasing/po/get-cek-oto-user'
        axios
            .get(url, {
                params: { sysdoctag_id: 4 },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setIsOto(data)
                    getCheckPO()
                    // Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }
    const getCheckPO = () => {
        const url = apiUrl.apiUrl + '/purchasing/po/get-cek-data-po/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data[0]
                    setOtNow(data?.ot_now)
                    setOtMax(data?.ot_max)
                    setIsAktif(data?.is_aktif)
                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }
    const navigate = useNavigate();
    interface FormInputs {
        pbsupplier_id: any
        pbpr_d_id: any
        mmbarang_id: any,
        qty: any,
        harga: any,
        keterangan: any,
        supplier: any,
        // supplier2: any,
        eta: any
    }
    const defaultValues = {
        pbpr_d_id: id,
        keterangan: ''
    }
    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })
    const convertComponent = [
        {
            key: "harga",
            renderCell: (row: any) => (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant='body2'>
                        {row.value || ""}
                    </Typography>
                    {canEdit && !hasReceived(row)
                        ?
                        <IconButton color="primary" size="small" onClick={() => {
                            Swal.fire({
                                title: 'Edit Harga',
                                html: `<input type="text" id="hargaInput" class="swal2-input" placeholder="Masukkan Harga Baru" value="${row.value}" />`,
                                showCancelButton: true,
                                confirmButtonText: 'Lanjut',
                                cancelButtonColor: '#ffc107',
                                didOpen: () => {
                                    const input = document.getElementById('hargaInput') as HTMLInputElement
                                    input?.focus()
                                },
                                preConfirm: () => {
                                    const input = document.getElementById('hargaInput') as HTMLInputElement
                                    const value = input?.value.replace(/[^\d,]/g, '')
                                    if (!value) {
                                        Swal.showValidationMessage('Harga tidak boleh kosong')
                                    }
                                    return value
                                }
                            }).then(result => {
                                if (result.isConfirmed) {
                                    const hargaBaru = result.value.replace(/,/g, '.')
                                    Swal.fire({
                                        title: 'Konfirmasi',
                                        text: `Ubah harga dari ${new Intl.NumberFormat('id-ID').format(parseFloat(row.value))} menjadi ${new Intl.NumberFormat('id-ID').format(hargaBaru)}?`,
                                        icon: 'question',
                                        showCancelButton: true,
                                        confirmButtonText: 'Ya, Ubah',
                                        confirmButtonColor: '#3085d6',
                                        cancelButtonColor: 'rgb(116, 107, 107)'
                                    }).then(konfirmasi => {
                                        if (konfirmasi.isConfirmed) {
                                            const data = {
                                                pbpo_d_id: row.data.pbpo_d_id,
                                                harga: parseFloat(hargaBaru)
                                            }
                                            const url = apiUrl.apiUrl + '/purchasing/po/edit-harga'
                                            axios.post(url, data, {
                                                headers: { Authorization: `Bearer ${token}` }
                                            }).then(response => {
                                                if (response.data.success) {
                                                    Swal.fire({
                                                        title: 'Berhasil',
                                                        text: response.data.message,
                                                        icon: 'success',
                                                        timer: 1000,
                                                        willClose: () => {
                                                            getDetail()
                                                        }
                                                    })
                                                } else {
                                                    Swal.fire({
                                                        title: 'Gagal',
                                                        text: response.data.message,
                                                        icon: 'error'
                                                    })
                                                }
                                            }).catch(error => {
                                                Swal.fire({
                                                    title: 'Error',
                                                    text: error.message,
                                                    icon: 'error'
                                                })
                                            })
                                        }
                                    })
                                }
                            })
                        }}>
                            <Icon icon="mdi:pencil" />
                        </IconButton>
                        : null
                    }
                </Box>
            ),
        },
        {
            key: "qty_order",
            renderCell: (row: any) => (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant='body2'>
                        {row.value || ""}
                    </Typography>
                    {canEdit
                        ?
                        <IconButton color="primary" size="small" onClick={() => {
                            Swal.fire({
                                title: 'Edit Qty Order',
                                html: `<input type="text" id="qtyOrderInput" class="swal2-input" placeholder="Masukkan Qty Order Baru" value="${row.value}" />`,
                                showCancelButton: true,
                                confirmButtonText: 'Lanjut',
                                cancelButtonColor: '#ffc107',
                                didOpen: () => {
                                    const input = document.getElementById('qtyOrderInput') as HTMLInputElement
                                    input?.focus()
                                },
                                preConfirm: () => {
                                    const input = document.getElementById('qtyOrderInput') as HTMLInputElement
                                    const value = input?.value.replace(/[^\d,]/g, '')
                                    if (!value) {
                                        Swal.showValidationMessage('Qty Order tidak boleh kosong')
                                    }
                                    return value
                                }
                            }).then(result => {
                                if (result.isConfirmed) {
                                    const qtyOrderBaru = result.value.replace(/,/g, '.')
                                    const qtyBaruNumber = Number(qtyOrderBaru)
                                    const qtySudahDatang = toNumber(row.data.qty_datang)

                                    if (!Number.isFinite(qtyBaruNumber) || qtyBaruNumber < qtySudahDatang) {
                                        Swal.fire({
                                            title: 'Tidak dapat mengubah Qty',
                                            text: `Qty PO tidak boleh lebih kecil dari qty yang sudah diterima (${qtySudahDatang}).`,
                                            icon: 'warning'
                                        })
                                        return
                                    }

                                    Swal.fire({
                                        title: 'Konfirmasi',
                                        text: `Ubah Qty Order dari ${row.value} menjadi ${qtyOrderBaru}?`,
                                        icon: 'question',
                                        showCancelButton: true,
                                        confirmButtonText: 'Ya, Ubah',
                                        confirmButtonColor: '#3085d6',
                                        cancelButtonColor: 'rgb(116, 107, 107)'
                                    }).then(konfirmasi => {
                                        if (konfirmasi.isConfirmed) {
                                            const data = {
                                                pbpo_d_id: row.data.pbpo_d_id,
                                                qty: qtyOrderBaru
                                            }
                                            const url = apiUrl.apiUrl + '/purchasing/po/edit-qty-barang'
                                            axios.post(url, data, {
                                                headers: { Authorization: `Bearer ${token}` }
                                            }).then(response => {
                                                if (response.data.success) {
                                                    Swal.fire({
                                                        title: 'Berhasil',
                                                        text: response.data.message,
                                                        icon: 'success',
                                                        timer: 1000,
                                                        willClose: () => {
                                                            getDetail()
                                                        }
                                                    })
                                                } else {
                                                    Swal.fire({
                                                        title: 'Gagal',
                                                        text: response.data.message,
                                                        icon: 'error'
                                                    })
                                                }
                                            }).catch(error => {
                                                Swal.fire({
                                                    title: 'Error',
                                                    text: error.message,
                                                    icon: 'error'
                                                })
                                            })
                                        }
                                    })
                                }
                            })
                        }}>
                            <Icon icon="mdi:pencil" />
                        </IconButton>
                        : null
                    }
                </Box>
            ),
        },
        {
            key: "nama_po",
            renderCell: (row: any) => (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant='body2'>
                        {row.value || ""}
                    </Typography>
                    {canEdit ?
                        <IconButton color="primary" size="small" onClick={() => {
                            Swal.fire({
                                title: 'Edit Nama Barang',
                                html: `<input type="text" id="namaBarangInput" class="swal2-input" placeholder="Masukkan Nama Barang Baru" value="${row.value}" />`,
                                showCancelButton: true,
                                confirmButtonText: 'Lanjut',
                                cancelButtonColor: '#ffc107',
                                didOpen: () => {
                                    const input = document.getElementById('namaBarangInput') as HTMLInputElement
                                    input?.focus()
                                },
                                preConfirm: () => {
                                    const input = document.getElementById('namaBarangInput') as HTMLInputElement
                                    const value = input?.value
                                    if (!value) {
                                        Swal.showValidationMessage('Nama barang tidak boleh kosong')
                                    }
                                    return value
                                }
                            }).then(result => {
                                if (result.isConfirmed) {
                                    const namaBarangBaru = result.value
                                    Swal.fire({
                                        title: 'Konfirmasi',
                                        text: `Ubah nama barang dari ${row.value} menjadi ${namaBarangBaru}?`,
                                        icon: 'question',
                                        showCancelButton: true,
                                        confirmButtonText: 'Ya, Ubah',
                                        confirmButtonColor: '#3085d6',
                                        cancelButtonColor: 'rgb(116, 107, 107)'
                                    }).then(konfirmasi => {
                                        if (konfirmasi.isConfirmed) {
                                            const data = {
                                                pbpo_d_id: row.data.pbpo_d_id,
                                                nama: namaBarangBaru
                                            }
                                            const url = apiUrl.apiUrl + '/purchasing/po/edit-nama-barang'
                                            axios.post(url, data, {
                                                headers: { Authorization: `Bearer ${token}` }
                                            }).then(response => {
                                                if (response.data.success) {
                                                    Swal.fire({
                                                        title: 'Berhasil',
                                                        text: response.data.message,
                                                        icon: 'success',
                                                        timer: 1000,
                                                        willClose: () => {
                                                            getDetail()
                                                        }
                                                    })
                                                } else {
                                                    Swal.fire({
                                                        title: 'Gagal',
                                                        text: response.data.message,
                                                        icon: 'error'
                                                    })
                                                }
                                            }).catch(error => {
                                                Swal.fire({
                                                    title: 'Error',
                                                    text: error.message,
                                                    icon: 'error'
                                                })
                                            })
                                        }
                                    })
                                }
                            })
                        }}>
                            <Icon icon="mdi:pencil" />
                        </IconButton>
                        : null}
                </Box>
            ),
        },
    ];
    const getHistoryPembelian = (datas: any) => {
        const url = apiUrl.apiUrl + '/purchasing/po/history-pembelian'
        axios
            .get(url, {
                params: {
                    id: datas.pbpo_d_id
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data.map((row: any, index: any) => ({
                        ...row,
                        id: index + 1
                    }));
                    if (data.some((item: any) => item.nama_item === datas.nama_barang)) {
                        setHistoryPembelian(data);
                    } else {
                        setHistoryPembelian([]);
                    }
                    setOpenDialogHistory(true)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }
    const handleDelete = (row: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin hapus data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: 'rgb(116, 107, 107)',
            confirmButtonText: 'Hapus'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })
                const data = {}
                const url = apiUrl.apiUrl + '/purchasing/po/hapus-barang/' + row.pbpo_d_id
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    getDetail()
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    };
    const ActionButtons = ({
        row
    }: {
        row: any
    }) => {
        return (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Tooltip key='History Pembelian' title='History Pembelian' placement='top'>
                    <a
                        onClick={() => getHistoryPembelian(row)}
                        style={{ cursor: 'pointer', textDecoration: 'none' }}
                    >
                        <IconButton component='span'>
                            <Icon icon='mdi:history' color='#0984e3' />
                        </IconButton>
                    </a>
                </Tooltip>
                {
                    canEdit && !hasReceived(row) ?
                        <Tooltip key='Hapus Data' title='Hapus Data' placement='top'>
                            <a
                                onClick={() => handleDelete(row)}
                                style={{ cursor: 'pointer', textDecoration: 'none' }}
                            >
                                <IconButton component='span'>
                                    <Icon icon='mdi:trash' color='#d63031' />
                                </IconButton>
                            </a>
                        </Tooltip>
                        : null
                }
            </Box>
        )
    }
    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                />
            ),
        },
    ];
    const onSubmit = (data: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: 'rgb(116, 107, 107)',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })
                let url = ''
                if (modeSave == 'save') {
                    url = apiUrl.apiUrl + '/purchasing/po/oto-po/' + id
                } else {
                    url = apiUrl.apiUrl + '/purchasing/po/edit-master-po/' + id
                }
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    const id = response.data.data
                                    navigate('/purchasing/purchase-order')
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }
    const onBatalOto = () => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin batal otorisasi data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: 'rgb(116, 107, 107)',
            confirmButtonText: 'Batal'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })
                const data = { id: id }
                const url = apiUrl.apiUrl + '/purchasing/po/batal-oto-po'
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    navigate('/purchasing/purchase-order')
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }
    const onBatalPO = () => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin batal PO ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: 'rgb(116, 107, 107)',
            confirmButtonText: 'Batal'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })
                const url = apiUrl.apiUrl + '/purchasing/po/batal-po/' + id
                axios
                    .delete(url, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    navigate('/purchasing/purchase-order')
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }
    const handleSelection = (data: any) => {
        setSelectedList(data.selectedRowsData)
        setSelectedPR(JSON.stringify(data.selectedRowsData))
    };
    const saveSelectedPrOutstanding = async () => {
        showToast("Loading", "loading");
        const send = {
            detail: selectedPR,
            pbpo_id: id,
        }
        let url = apiUrl.apiUrl + '/purchasing/po/add-pr-outstanding'
        axios
            .post(url, send, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    showToast(response.data.message, "success");
                    setOpenDialogPrOutstanding(false);
                    getDetail();
                } else {
                    showToast(response.data.message, "error");
                }
            })
            .catch(error => {
                showToast(error.message, "error");
            })
    }
    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Detail Purchase Order
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        No. Dokumen : <b>{id}</b>
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        Tgl. Dokumen : <b>{pTgl}</b>
                    </Typography>
                    {isAktif == '0' ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', my: 3 }}>
                            <Tooltip title='Kirim WhatsApp Otorisasi'>
                                <Button
                                    variant='contained'
                                    color={isKirimWa ? 'warning' : 'success'}
                                    startIcon={isKirimWa ? <Icon icon='mdi:reload' /> : <Icon icon='mdi:whatsapp' />}
                                    onClick={() => {
                                        Swal.fire({
                                            title: 'Konfirmasi',
                                            text: 'Kirim pesan WhatsApp untuk otorisasi?',
                                            icon: 'question',
                                            showCancelButton: true,
                                            confirmButtonText: 'Kirim',
                                            confirmButtonColor: '#3085d6',
                                            cancelButtonColor: 'rgb(116, 107, 107)'
                                        }).then(result => {
                                            if (result.isConfirmed) {
                                                Swal.fire({
                                                    title: 'Now loading',
                                                    allowEscapeKey: false,
                                                    allowOutsideClick: false,
                                                    didOpen: () => {
                                                        Swal.showLoading()
                                                    }
                                                })
                                                const url = apiUrl.apiUrl + '/purchasing/po/kirim-otorisasi/' + id
                                                axios.post(url, {}, {
                                                    headers: { Authorization: `Bearer ${token}` }
                                                }).then(response => {
                                                    if (response.data.success) {
                                                        Swal.fire({
                                                            title: 'Berhasil',
                                                            text: response.data.message,
                                                            icon: 'success',
                                                            timer: 1000
                                                        })
                                                    } else {
                                                        Swal.fire({
                                                            title: 'Gagal',
                                                            text: response.data.message,
                                                            icon: 'error'
                                                        })
                                                    }
                                                }).catch(error => {
                                                    Swal.fire({
                                                        title: 'Error',
                                                        text: error.message,
                                                        icon: 'error'
                                                    })
                                                })
                                            }
                                        })
                                    }}
                                >
                                    {isKirimWa ? 'Kirim Ulang Notifikasi Whatsapp' : 'Kirim WhatsApp Otorisasi'}
                                </Button>
                            </Tooltip>
                        </Box>
                    ) :
                        null
                    }
                    <Divider sx={{ m: 5 }} />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='supplier'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Nama Supplier'
                                                error={Boolean(errors.supplier)}
                                                onChange={onChange}
                                                value={value}
                                                inputProps={{ readOnly: true }}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.supplier && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Keterangan'
                                                rows={2}
                                                multiline
                                                error={Boolean(errors.keterangan)}
                                                onChange={onChange}
                                                value={value}
                                                inputProps={{ readOnly: false }}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.keterangan && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        gap: 2,
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        p: theme => theme.spacing(2, 0, 0, 0)
                                    }}
                                >
                                    <Button
                                        size='large'
                                        sx={{ mr: 2, width: 150 }}
                                        variant='contained'
                                        onClick={() => setModeSave('edit')}
                                        type='submit'
                                        disabled={isAktif == '1' ? true : false}
                                    >
                                        Simpan
                                    </Button>
                                </Box>
                            </Grid>
                            {
                                canEdit ?
                                    <Grid item xs={12} sm={12} sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                                        <Tooltip title='Tambah Request'>
                                            <Fab color='primary' size='small' onClick={() => {
                                                setSelectedList([]);
                                                setSelectedPR(null);
                                                getPrOutStanding();
                                                setOpenDialogPrOutstanding(true)
                                            }}>
                                                <Icon icon='mdi:plus' />
                                            </Fab>
                                        </Tooltip>
                                    </Grid>
                                    : null
                            }
                            <Grid item xs={12} sm={12}>
                                <MsiDatagridAutoPlain array={listDetail} actions={actionData} customRender={convertComponent} hiddenColumns={['id', 'pbpo_d_id', 'pbpo_id', 'mmbarang_id', 'kode_barang', 'konversi', 'valas', 'created_at', 'updated_at', 'deleted_at', 'created_by', 'updated_by', 'deleted_by', 'jenis_barang', 'keterangan', 'tgl_kebutuhan', 'total_valas_ppn']} />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'flex-end',
                                    pr: 3,
                                    gap: 0.75
                                }}
                            >
                                {[
                                    { label: 'Total Barang', value: totalAll.jumlah_barang || 0 },
                                    { label: 'Total Qty Order', value: totalAll.qty_order || 0 },
                                    { label: 'Total Qty Datang', value: totalAll.qty_datang || 0 },
                                    {
                                        label: 'Total Harga',
                                        value: `Rp ${new Intl.NumberFormat('id-ID').format(totalAll.total || 0)}`
                                    }
                                ].map((item, idx) => (
                                    <Box
                                        key={idx}
                                        sx={{
                                            display: 'grid',
                                            gridTemplateColumns: 'auto 12px auto', // label | : | value
                                            alignItems: 'center',
                                            justifyContent: 'end',
                                            columnGap: 1
                                        }}
                                    >
                                        <Typography
                                            variant="body1"
                                            color="text.secondary"
                                            sx={{ textAlign: 'right', whiteSpace: 'nowrap' }}
                                        >
                                            {item.label}
                                        </Typography>
                                        <Typography
                                            variant="body1"
                                            color="text.secondary"
                                            sx={{ textAlign: 'center' }}
                                        >
                                            :
                                        </Typography>
                                        <Typography
                                            variant="body1"
                                            sx={{ textAlign: 'right', whiteSpace: 'nowrap' }}
                                        >
                                            {item.value}
                                        </Typography>
                                    </Box>
                                ))}
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            spacing={2}
                            sx={{
                                display: 'flex',
                                flexDirection: { xs: 'column', sm: 'row' },
                                alignItems: 'center',
                                justifyContent: 'center',
                                mt: 5
                            }}
                        >
                            {(() => {
                                if (isOto == '0' && isAktif == '1') {
                                    return null
                                } else if (isOto == '0' && otNow == '0' && isAktif == '0') {
                                    return (
                                        <Button
                                            size="large"
                                            sx={{ width: { xs: '100%', sm: 150 }, mr: 2 }}
                                            variant="contained"
                                            color="error"
                                            onClick={onBatalPO}
                                        >
                                            BATAL PO
                                        </Button>
                                    )
                                } else if (isOto < otNow && otNow > 0 && isAktif == '0') {
                                    return (
                                        <Button
                                            size="large"
                                            sx={{ width: { xs: '100%', sm: 150 }, mr: 2 }}
                                            variant="contained"
                                            color="error"
                                            onClick={onBatalPO}
                                        >
                                            BATAL PO
                                        </Button>
                                    )
                                } else if (isOto > otNow && isAktif == '0') {
                                    return (
                                        <>
                                            <Button
                                                size="large"
                                                sx={{ width: { xs: '100%', sm: 150 }, mr: 2 }}
                                                variant="contained"
                                                color="error"
                                                onClick={onBatalPO}
                                            >
                                                BATAL PO
                                            </Button>
                                            <Button
                                                size="large"
                                                color="success"
                                                sx={{ width: { xs: '100%', sm: 250 }, mr: 2 }}
                                                variant="contained"
                                                onClick={() => setModeSave('save')}
                                                type="submit"
                                            >
                                                Otorisasi & Simpan
                                            </Button>
                                        </>
                                    )
                                } else if (isOto == otNow && otNow > 0 && isAktif == '0') {
                                    return (
                                        <>
                                            <Button
                                                size="large"
                                                sx={{ width: { xs: '100%', sm: 150 }, mr: 2 }}
                                                variant="contained"
                                                color="error"
                                                onClick={onBatalPO}
                                            >
                                                BATAL PO
                                            </Button>
                                            <Button
                                                size="large"
                                                color="error"
                                                sx={{ width: { xs: '100%', sm: 250 }, mr: 2 }}
                                                variant="contained"
                                                onClick={onBatalOto}
                                            >
                                                Batal Otorisasi
                                            </Button>
                                        </>
                                    )
                                } else if (isOto == otNow && otNow > 0) {
                                    return (
                                        <Button
                                            size="large"
                                            color="error"
                                            sx={{ width: { xs: '100%', sm: 250 }, mr: 2 }}
                                            variant="contained"
                                            onClick={onBatalOto}
                                        >
                                            Batal Otorisasi
                                        </Button>
                                    )
                                } else if (isOto < otNow && otNow > 0 && isAktif == '1') {
                                    return null
                                } else if (isOto < otNow && otNow > 0) {
                                    return (
                                        <Button
                                            size="large"
                                            sx={{ width: { xs: '100%', sm: 150 }, mr: 2 }}
                                            variant="contained"
                                            color="error"
                                            onClick={onBatalPO}
                                        >
                                            BATAL PO
                                        </Button>
                                    )
                                } else if (isOto == '0' && otNow == '0') {
                                    return (
                                        <Button
                                            size="large"
                                            sx={{ width: { xs: '100%', sm: 150 }, mr: 2 }}
                                            variant="contained"
                                            color="error"
                                            onClick={onBatalPO}
                                        >
                                            BATAL PO
                                        </Button>
                                    )
                                } else {
                                    return null
                                }
                            })()}
                        </Grid>
                    </form>
                </div>
            </Grid>
            <Dialog
                maxWidth={'xl'}
                fullWidth={true}
                open={openDialogHistory}
                onClose={() => setOpenDialogHistory(false)}
            >
                <DialogTitle>
                    <Typography variant='body1' sx={{ fontWeight: 500, my: 1.5, color: '#212121' }}>
                        HISTORY PEMBELIAN
                    </Typography>
                </DialogTitle>
                <DialogContent sx={{ pt: 1 }}>
                    <MsiDatagrid array={historyPembelian} hiddenColumns={['id']} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialogHistory(false)} color='inherit'>
                        Batal
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                maxWidth={'xl'}
                fullWidth={true}
                open={openDialogPrOutstanding}
                onClose={() => setOpenDialogPrOutstanding(false)}
            >
                <DialogTitle>
                    <Typography variant='body1' sx={{ fontWeight: 500, my: 1.5, color: '#212121' }}>
                        LIST PR OUTSTANDING
                    </Typography>
                </DialogTitle>
                <DialogContent sx={{ pt: 1 }}>
                    {selectedList.length > 0 ? (
                        <Box
                            sx={{
                                gap: 2,
                                display: 'flex',
                                flexWrap: 'wrap',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                p: theme => theme.spacing(2, 0, 0, 0)
                            }}
                        >
                            <Button
                                variant='outlined'
                                onClick={saveSelectedPrOutstanding}
                                startIcon={<Icon icon='mdi:text-box-check-outline' />}
                            >
                                Tambahkan {selectedList.length} Item Request
                            </Button>
                        </Box>
                    ) : null}
                    <MsiDatagridCheckbox array={listPrOutStanding} handleSelection={handleSelection} hiddenColumns={['mmbarang_id']} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialogPrOutstanding(false)} color='inherit'>
                        Batal
                    </Button>
                </DialogActions>
            </Dialog>
            <AttachmentFab
                docId={Number(id)}
                docType="pbpo"
            />
        </Grid>
    )
}